import { render } from "./BaseCard.vue?vue&type=template&id=53fbba66&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=53fbba66&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53fbba66"

export default script